import _objectSpread from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "dialog-footer"
};
import { ref, watch, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { user_list_simple, approval_change } from "@/api/apis";
export default {
  __name: 'TransferDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "转审"
    },
    approverLabel: {
      type: String,
      default: "审批人"
    },
    transferParams: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:modelValue", "success", "close", "error"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var dialogVisible = ref(false);
    var selectedApprover = ref(null);
    var userList = ref([]);
    var userLoading = ref(true);
    var confirmLoading = ref(false);

    // 获取用户列表
    var fetchUserList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        try {
          var _res$data;
          userLoading.value = true;
          var res = yield user_list_simple({});
          userList.value = (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || [];
        } catch (error) {
          ElMessage({
            type: "error",
            message: "获取审批人列表失败"
          });
        } finally {
          userLoading.value = false;
        }
      });
      return function fetchUserList() {
        return _ref2.apply(this, arguments);
      };
    }();
    watch(() => props.modelValue, val => {
      dialogVisible.value = val;
      if (val) {
        fetchUserList();
        selectedApprover.value = null;
      } else {
        selectedApprover.value = null;
      }
    });

    // 监听 dialogVisible 变化
    watch(dialogVisible, val => {
      emit("update:modelValue", val);
    });
    var handleClose = () => {
      dialogVisible.value = false;
      emit("close");
    };
    var handleConfirm = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* () {
        var _selectedApprover$val;
        if (!((_selectedApprover$val = selectedApprover.value) !== null && _selectedApprover$val !== void 0 && _selectedApprover$val.id)) {
          ElMessage({
            type: "warning",
            message: "\u8BF7\u9009\u62E9".concat(props.approverLabel)
          });
          return;
        }
        try {
          confirmLoading.value = true;
          var transferData = _objectSpread(_objectSpread({}, props.transferParams), {}, {
            approval_user_id: selectedApprover.value.id,
            approval_user_name: selectedApprover.value.name
          });
          approval_change(transferData, "post").then(res => {
            if (res.code == 200) {
              ElMessage({
                type: "success",
                message: "操作成功"
              });
              dialogVisible.value = false;
              emit("success", selectedApprover.value, res);
            }
          });
        } catch (error) {} finally {
          confirmLoading.value = false;
        }
      });
      return function handleConfirm() {
        return _ref3.apply(this, arguments);
      };
    }();

    // 组件挂载时初始化
    onMounted(() => {
      if (props.modelValue) {
        fetchUserList();
      }
    });
    return (_ctx, _cache) => {
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_form = _resolveComponent("el-form");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event),
        title: __props.title,
        width: "500",
        "align-center": "",
        onClose: handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleConfirm,
          loading: confirmLoading.value
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" 确定 ")])),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "120",
          "label-position": "left",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: __props.approverLabel,
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: selectedApprover.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedApprover.value = $event),
              filterable: "",
              placeholder: "\u8BF7\u9009\u62E9".concat(__props.approverLabel),
              style: {
                "width": "70%"
              },
              "value-key": "id",
              loading: userLoading.value,
              disabled: userLoading.value
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "placeholder", "loading", "disabled"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};